import { makeAutoObservable } from 'mobx'
import { showToast } from 'shared/ui'
import type { IEntitiesStore } from 'entities/EntitiesExport'

export class CallPopUpRingingStore {
  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  get callStore() {
    return this._entities.callStore
  }

  private get _entries() {
    return this.callStore.ringingEntries
  }

  get items() {
    return this._entries.map((entry) => entry.callContact)
  }

  get hasItems() {
    return this._entries.length > 0
  }

  get count() {
    return this._entries.length
  }

  get loading() {
    return false
  }

  handleAccept = async (callSid: string) => {
    const primary = this.callStore.primaryEntry
    if (primary && primary.isOpen && !primary.isHold && primary.callSid !== callSid) {
      const response = await this.callStore.holdCall(primary.callSid)
      if (!response) {
        showToast({
          type: 'error',
          title: "Couldn't put the active call on hold. Please try again.",
        })
        return
      }
    }
    this.callStore.acceptCall(callSid)
  }

  handleDecline = (callSid: string) => {
    void this.callStore.disconnectCall(callSid, true)
  }

  handleDeclineAll = () => {
    this._entries.forEach((entry) => void this.callStore.disconnectCall(entry.callSid, true))
  }
}
